import React from "react";
import { Button, IconButton } from "@mui/material";
import NestedDropdown from "./NestedDropDown";
import PackShotAndThumbnail from "./PackshotAndThumbnail";
import GeneratePackshots from "./GeneratePackshots";
import { useSelector } from "react-redux";

const DrillDown = () => {
  const { packshots, open, clickedThumbnail, selectedSku } = useSelector(
    (state) => state.conflictsPageStore
  );
  const {
    conflicts,
    curConflict,
    conflictedBrands,
    selectedConflictBrand,
    selectedThumbnailsToMarkCorrect,
  } = useSelector((state) => state.conflictDataStore);

  return (
    <>
      <NestedDropdown {...clickedThumbnail} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
        //   marginBottom: "2rem",
        }}
      >
        <PackShotAndThumbnail
          selectedThumbnailsToMarkCorrect={selectedThumbnailsToMarkCorrect}
        />
        <GeneratePackshots packshots={packshots} />
      </div>
    </>
  );
};

export default DrillDown;
